/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Prep_AheadInputs */

const en_editor_prep_ahead = /** @type {(inputs: Editor_Prep_AheadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prep ahead (the day before)`)
};

const de_editor_prep_ahead = /** @type {(inputs: Editor_Prep_AheadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorbereiten (am Vortag)`)
};

/**
* | output |
* | --- |
* | "Prep ahead (the day before)" |
*
* @param {Editor_Prep_AheadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_prep_ahead = /** @type {((inputs?: Editor_Prep_AheadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Prep_AheadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_prep_ahead(inputs)
	return en_editor_prep_ahead(inputs)
});